import React from 'react';
import { SERVICE_TYPE_CONFIG, SERVICE_TYPES } from '../../constants/orderFormConstants';

const ServiceDetails = ({
  service,
  serviceList,
  selectedServiceId,
  service_type,
  servicePrice,
  showFullDescription,
  toggleDescription
}) => {
  if (!service) return null;

  const serviceConfig = SERVICE_TYPE_CONFIG[service_type] || {};
  const currentService = serviceList.find(s => s && s.id === selectedServiceId);

  return (
    <>
      <div className="flex items-center gap-2 group">
        <button
          className="relative group uppercase text-xs font-bold tracking-wide p-1 rounded-lg focus:outline-none focus:shadow-outline transition duration-500 text-white"
          style={{
            width: "fit-content",
            background: service_type === SERVICE_TYPES.INSTANT ? SERVICE_TYPE_CONFIG[SERVICE_TYPES.INSTANT].gradient : SERVICE_TYPE_CONFIG[SERVICE_TYPES.NORMAL].gradient,
          }}
        >
          {service_type === SERVICE_TYPES.INSTANT ? SERVICE_TYPE_CONFIG[SERVICE_TYPES.INSTANT].label : SERVICE_TYPE_CONFIG[SERVICE_TYPES.NORMAL].label}
        </button>

        <span className="text-gray-600 my-2">
          Price:{" "}
          <span className="text-black font-bold">
            ${servicePrice}
          </span>
          / 1000 units
        </span>

        {/* Tooltip */}
        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
          {serviceConfig.description}
        </span>
      </div>

      <label className="text-black font-medium mt-2 mb-3">
        Service Description :
      </label>
      {currentService && (
        <div>
          <p
            className={`text-gray-500 ${
              showFullDescription ? "whitespace-pre-wrap" : "whitespace-pre-wrap"
            }`}
          >
            {showFullDescription
              ? currentService.description
              : currentService.description.slice(0, 50) +
                (currentService.description.length > 50 ? "..." : "")}
          </p>
          {currentService.description.length > 50 && (
            <button
              onClick={toggleDescription}
              className="text-blue-500 underline cursor-pointer"
            >
              {showFullDescription ? "Show Less" : "Show More"}
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default ServiceDetails;
